import { useDeleteCoupon, usePostCoupon } from "@/api/AppApi/services/cart";
import { useEffect, useRef, useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import SvgPromoCorrect from "./promo-icons/SvgPromoCorrect";
import SvgPromoInvalid from "./promo-icons/SvgPromoInvalid";
import Price from "../../../lib/Price";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "../../../lib/CustomButton";
import SpinnerForBtn from "../../../lib/loaders/SpinnerForBtn";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  promoCode: string;
  promoDiscount: number;
  country_code: string;
}
enum PromoRes {
  valid = "valid",
  invalid = "invalid",
  none = "none",
}
const PromoInput: React.FC<Props> = ({
  promoCode,
  promoDiscount,
  country_code,
}) => {
  const t = useTranslation();
  const applyText = t.apply;
  const clearText = t.clear;
  const retryText = t.retry;
  const [value, setValue] = useState(promoCode);
  const inputRef = useRef<any>(null);
  const [correct, setcorrect] = useState<PromoRes>(PromoRes.none);
  const resetPromo = () => {
    setValue(promoCode);
    setcorrect(promoCode === "" ? PromoRes.none : PromoRes.valid);
  };
  const resetInput = () => {
    setValue("");
    setcorrect(PromoRes.none);
    inputRef.current?.focus();
  };
  const postCoupon = usePostCoupon({
    onSuccess: () => {},
    onError: () => {
      setcorrect(PromoRes.invalid);
    },
  });
  const deleteCoupon = useDeleteCoupon({
    onSuccess: () => {
      resetInput();
    },
    onError: (_error) => {
    },
  });
  useEffect(() => {
    resetPromo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promoCode, country_code]);

  const handleClick = () => {
    switch (correct) {
      case PromoRes.none:
        postCoupon.mutate({ code: value, country_code });
        break;
      case PromoRes.valid:
        deleteCoupon.mutate();
        break;
      default:
        resetPromo();
    }
  };
  const btnCaption =
    correct === PromoRes.none
      ? applyText
      : correct === PromoRes.invalid
      ? retryText
      : clearText;
  // const btnClassName = `promo-btn ${
  //   !value ? "disable" : correct === PromoRes.none || postCoupon.isLoading ? "primary-btn" : "clear"
  // }`;
  return (
    <Row className="m-0 align-items-center promo-input">
      <Col className="p-0">
        <input
          type="text"
          ref={inputRef}
          autoComplete="new-password"
          placeholder={t.enter_a_promo_code_here}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setcorrect(PromoRes.none);
          }}
        />
      </Col>
      {correct !== PromoRes.none && (
        <Col className="p-0 col-auto">
          {correct === PromoRes.valid ? (
            <Row className="m-0 align-items-center">
              <Col className="col-auto p-0" style={{ marginInlineEnd: 4 }}>
                <SvgPromoCorrect />
              </Col>
              <Col className="p-0 promo-correct">
                <Price price={{ value: promoDiscount, className: "" }} />
              </Col>
            </Row>
          ) : (
            <>
              <Row className="m-0 p-0 align-items-center">
                <Col className="col-auto p-0" style={{ marginInlineEnd: 4 }}>
                  <SvgPromoInvalid />
                </Col>
                <Col className="p-0 promo-invalid">{t.invalid_or_expired}</Col>
              </Row>
            </>
          )}
        </Col>
      )}
      <Col className="p-0 col-auto promo-seperator" />
      <Col className="p-0 col-auto" style={{ width: 96 }}>
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.large}
          radius={BtnRadius.none}
          onClick={handleClick}
          notAllowed={!value}
          fullWidth
        >
          {postCoupon.isLoading ? <SpinnerForBtn /> : btnCaption}
        </CustomButton>
      </Col>
    </Row>
  );
};

export default PromoInput;
